import { ReactElement } from "react"

import { Stack, Typography } from "@/generated/material"
import { StackProps } from "@/generated/material/Stack"
import { useIsDesktop } from "@/utils/useIsDesktop"

interface DetailFieldProps {
  label: string
  children: ReactElement | string
  testId: string
  variant?: "box" | "text"
}

export const DetailField = ({
  label,
  children,
  testId,
  variant = "text",
  ...props
}: DetailFieldProps & Partial<StackProps>) => {
  const isDesktop = useIsDesktop()

  return (
    <Stack
      direction="row"
      gap={"md"}
      minHeight={isDesktop ? "auto" : 28}
      alignItems={"center"}
      bgcolor={variant === "box" ? "transparent" : "transparent"}
      borderRadius={({ uisk: { radius } }) => radius.sm}
      border={({ palette }) =>
        variant === "box" ? `1px solid ${palette["border-secondary"]}` : "none"
      }
      flex={1}
      paddingX="md"
      {...props}
    >
      <Typography variant="Text sm/Regular" color="text-tertiary">
        {label}
      </Typography>
      <Typography
        variant="Text md/Regular"
        color="text.primary"
        data-testid={testId}
      >
        {children}
      </Typography>
    </Stack>
  )
}
